import { Page } from '../../../../../components/page/page';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../../features/restore-modal/restore-modal';
import { LeadsCards } from './leads-cards/leads-cards';
import { LeadsControls } from './leads-controls/leads-controls';
import { LeadsTable } from './leads-table/leads-table';
import s from './list-leads.module.css';
import { useLeads } from './use-leads';

export const ListLeads = () => {
  const { t, restoreLead, deleteLead, viewStyle, list } = useLeads();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {t('Лиды')} ({list?.length})
        <LeadsControls />
      </h2>

      {viewStyle === 'table' ? <LeadsTable /> : <LeadsCards />}

      <HasAccess service="lead" permissions={['write']}>
        <RestoreModal onSubmit={restoreLead} />
        <DeleteModal onSubmit={deleteLead} />
      </HasAccess>
    </Page>
  );
};
